// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function getDeep(obj: Record<string, unknown>, ...keys: string[]): unknown {
  return keys.reduce((acc, k) => (acc as any)?.[k], obj as unknown)
}

export function setDeep(obj: Record<string, unknown>, keys: string[], value: unknown): Record<string, unknown> {
  if (keys.length === 0) return obj
  const [head, ...rest] = keys as [string, ...string[]]
  if (rest.length === 0) return { ...obj, [head]: value }
  const child = (obj[head] as Record<string, unknown>) ?? {}
  return { ...obj, [head]: setDeep(child, rest, value) }
}
